<template>
  <div class="container">
    <button class="carouselLeftButton" v-on:click="previousSlide()">Previous</button>
    <button class="carouselRightButton" v-on:click="nextSlide()">Next</button>
    <div class="carousel-slide">
      <img :src="currentImage" alt="an image">
    </div>
  </div>
</template>

<script>
export default {
  name: "CarouselComponent",
  data(){
    return{
      slides: [require('../assets/trees.jpeg'), require("../assets/landscape.jpeg"),require("../assets/swim.jpeg")],
      currentSlide:0,
    }
  },
  computed:{
    currentImage(){
      return this.slides[this.currentSlide]
    }
  },
  methods:{
    nextSlide(){
       if (this.currentSlide < this.slides.length - 1){this.currentSlide += 1}
    },
    previousSlide(){
      if (this.currentSlide > 0){this.currentSlide -=1}
    }
  }
}
</script>

<style scoped>
.container{
  margin-top: 5%;
}
.carousel-slide{
  display: flex;
}
.carousel-slide img {
  width: 80%;
  margin-left: 10%;
  display: flex;
  position: center;
}
button{
  display: flex;
  background-color: darkgoldenrod;
  width: 100px;
  height: 50px;
  border-radius: 20px;
  text-align: center;
  padding-top: 10px;
  padding-left: 10px;
  color: white;
}
.carouselLeftButton{
  float: left;
  margin-left: 10%;
  margin-top: 15%;
}
.carouselRightButton{
  float: right;
  margin-right: 10%;
  margin-top: 15%;
}
</style>